import React from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import UsageDetailView, { Field, UsageDetailPage, UsageEntriesQuery } from '../components/converter/UsageDetailView';
import { fromHere } from '../hooks/useBackTo';
import { apiService } from '../services/api';
import { WebUsageJob } from '../types';
import { formatDateTimeUTC, formatDuration } from '../utils/dateTime';

async function loadJob(id: string, query: UsageEntriesQuery): Promise<UsageDetailPage<WebUsageJob>> {
    const res = await apiService.webGetUsageJob(id, query);
    return { subject: res.data.job, entries: res.data.usage || [], total: res.data.total || 0 };
}

function WebJobDetail() {
    const { id } = useParams<{ id: string }>();
    const location = useLocation();

    return (
        <UsageDetailView<WebUsageJob>
            id={id}
            backTo="/usage?tab=web"
            pageSizeKey="web-job-files"
            load={loadJob}
            noun="job"
            title={(job) => job.project_name || job.operation}
            titleAside={(job) => job.status === 'deleted' ? (
                <span className="text-secondary">deleted</span>
            ) : (
                <Link
                    to={job.operation === 'convert' ? `/converter/jobs/${job.id}` : `/jobs/${job.id}`}
                    state={fromHere(location)}
                    className="text-sm text-primary hover:underline"
                >
                    Open job
                </Link>
            )}
            fields={(job) => (
                <>
                    <Field label="Operation">{job.operation}</Field>
                    <Field label="Started At">{formatDateTimeUTC(job.started_at)}</Field>
                    <Field label="Completed At">{formatDateTimeUTC(job.completed_at)}</Field>
                    <Field label="Duration">{job.started_at ? formatDuration(job.started_at, job.completed_at) : '—'}</Field>
                </>
            )}
        />
    );
}

export default WebJobDetail;
